module.exports = __webpack_public_path__ + "img/ikon_abborre.b18b58fe.svg";